import * as R from 'ramda';
import { connect, useDispatch } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import React, { useState, useEffect, useCallback } from 'react';
import {
  compose,
  withState,
  lifecycle,
} from 'react-recompose';
// components
import { openModal, closeModal } from '../../components/modal/actions';
// features
import { sendLogOutRequest } from '../auth/actions';
import { switchBranchRequest } from '../branch/actions';
import { makeSelectUnreadCount } from '../notification/selectors';
import { makeSelectCurrentUserSettingsFields } from '../profile/selectors';
import { setExpandedContainerOptions } from '../expanded-container/actions';
import { makeSelectStyling, makeSelectMainStyling } from '../styling/selectors';
import { makeSelectCurrentBranch, makeSelectBranchesTree } from '../branch/selectors';
import { makeSelectShipmentList, makeSelectAuthorizedLoadBoards } from '../load-board/selectors';
// helpers/constants
import * as G from '../../helpers';
import { getCurrentMenuItem } from '../../helpers/menu';
// feature navbar-menu
import CarrierMenu from './components/carrier-menu';
import RegularMenu from './components/regular-menu';
import { toggleDevMode, clickOnItemAction } from './actions';
//////////////////////////////////////////////////

const enhance = compose(
  withState('currentMenuItem', 'setCurrentMenuItem', getCurrentMenuItem()),
  lifecycle({
    componentDidUpdate({currentMenuItem, setCurrentMenuItem}) {
      const current = getCurrentMenuItem();

      if (G.notEquals(current, currentMenuItem)) {
        setCurrentMenuItem(current);
      }
    },
  }),
);

const NavbarMenuComponent = (props) => {
  const dispatch = useDispatch();

  const [isDevMode, setIsDevMode] = useState(G.isDevMode());

  const handleToggleDevMode = useCallback((ev) => {
    const { ctrlKey, keyCode, shiftKey } = ev;

    if (G.isAllTrue(ctrlKey, shiftKey, R.equals(keyCode, 192))) {
      G.toggleDevMode();

      setIsDevMode(G.isDevMode());

      dispatch(toggleDevMode());
    }
  }, []);

  useEffect(() => {
    window.addEventListener('keydown', handleToggleDevMode);

    return () => window.removeEventListener('keydown', handleToggleDevMode);
  }, []);

  const isCarrier = G.isCurrentUserTypeCarrier();

  if (isCarrier) return <CarrierMenu {...props} />;

  return <RegularMenu {...props} isDevMode={isDevMode} />;
};

const mapStateToProps = (state) => createStructuredSelector({
  styling: makeSelectStyling(state),
  rootBranch: makeSelectBranchesTree(state),
  mainStyling: makeSelectMainStyling(state),
  currentBranch: makeSelectCurrentBranch(state),
  loadBoardShipments: makeSelectShipmentList(state),
  unreadNotificationsCount: makeSelectUnreadCount(state),
  authorizedLoadBoards: makeSelectAuthorizedLoadBoards(state),
  currentUserSettings: makeSelectCurrentUserSettingsFields(state),
});

export default connect(mapStateToProps, {
  openModal,
  closeModal,
  toggleDevMode,
  clickOnItemAction,
  sendLogOutRequest,
  switchBranchRequest,
  setExpandedContainerOptions,
})(enhance(NavbarMenuComponent));
